import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
import moment from 'moment'
import 'react-responsive-modal/styles.css'
import { Modal } from 'react-responsive-modal'
import Constant from '../../Constant'
import CustomFooter from '../../common/TableBottom'
import Loader from '../../common/Loader'
import './PushNotification.css'

class PushHistory extends React.Component {
  state = {
    campaigns: [],
    isLoading: false,
    keyword: '',
    limit: 10,
    pageNumber: 0,
    totalCount: 0,
    totalPages: 0,
    disabled: false,

    detailOpen: false,
    detailLoading: false,
    detail: null
  }

  debounceTimeout = null

  componentDidMount() {
    this.loadData()
  }

  loadData = () => {
    this.setState({ isLoading: true })

    const params = {
      pageNumber: this.state.pageNumber,
      limit: this.state.limit
    }

    if (this.state.keyword) {
      params.keyword = this.state.keyword
    }

    axios
      .get(Constant.getAPI() + `/push-campaigns/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: params,
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            isLoading: false,
            campaigns: res.data.data || [],
            totalCount: res.data.pagination?.count || 0,
            totalPages: res.data.pagination?.pages || 0,
            disabled: this.state.pageNumber + 1 >= res.data?.pagination?.pages,
          })
        } else {
          this.setState({ isLoading: false })
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title:
              err?.response?.data?.data?.details?.[0]?.message ||
              err?.response?.data?.message ||
              'Failed to load push campaigns',
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.loadData()
        }, 500)
      }
    )
  }

  clearSearch = (hideSearch) => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        if (typeof hideSearch === 'function') {
          hideSearch()
        }
        this.loadData()
      }
    )
  }

  deepLinkSectionLabels = {
    C: 'Cruise Category',
    Y: 'Cruise',
    T: 'Trip',
    E: 'Event',
    D: 'Destination',
    S: 'Store',
    CH: 'Chalet'
  }

  segmentLabels = {
    all_kuwait: 'Kuwait Users',
    all_uae: 'UAE Users',
    all_ksa: 'KSA Users',
    active_30d: 'Signed Up in Last 30 Days',
    inactive_30d: 'Signed Up More Than 30 Days Ago'
  }

  openDetail = (id) => {
    if (!id) return

    this.setState({ detailOpen: true, detailLoading: true, detail: null })

    axios
      .get(Constant.getAPI() + `/push-campaigns/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data && res.data.success) {
          this.setState({ detail: res.data.data, detailLoading: false })
        } else {
          this.setState({ detailLoading: false })
        }
      })
      .catch((err) => {
        this.setState({ detailOpen: false, detailLoading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire('Error', err?.response?.data?.message || 'Failed to load campaign details', 'error')
        }
      })
  }

  closeDetail = () => {
    this.setState({ detailOpen: false, detail: null })
  }

  getTargetUserCount = (detail) => {
    if (!detail || !detail.target_user_ids) return 0
    try {
      const parsed = typeof detail.target_user_ids === 'string' ? JSON.parse(detail.target_user_ids) : detail.target_user_ids
      return Array.isArray(parsed) ? parsed.length : 0
    } catch (e) {
      return 0
    }
  }

  renderStatusBadge = (status) => {
    const value = (status || 'sent').toLowerCase()
    let color = '#6c757d'
    let bg = '#f8f9fa'

    if (value === 'sent') { color = '#28a745'; bg = '#d4edda' }
    else if (value === 'scheduled') { color = '#004085'; bg = '#cce5ff' }
    else if (value === 'sending') { color = '#856404'; bg = '#fff3cd' }
    else if (value === 'failed') { color = '#721c24'; bg = '#f8d7da' }

    return (
      <span style={{ padding: '4px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: '600', color: color, backgroundColor: bg, textTransform: 'capitalize' }}>
        {value}
      </span>
    )
  }

  getClickAction = (detail) => {
    if (detail.click_action === 'url') {
      return { main: 'Open URL', sub: detail.click_action_value || '' }
    }
    if (detail.click_action === 'deeplink') {
      const section = this.deepLinkSectionLabels[detail.deep_link_type] || detail.deep_link_type || '-'
      return { main: `Deep Link · ${section}`, sub: detail.deep_link_id || '' }
    }
    return { main: 'Open App Home', sub: '' }
  }

  getAudienceText = (detail) => {
    if (detail.audience_type === 'segment') {
      return `Segment · ${this.segmentLabels[detail.segment_name] || detail.segment_name || '-'}`
    }
    if (detail.audience_type === 'users') {
      const count = this.getTargetUserCount(detail)
      return `${count} Selected User${count === 1 ? '' : 's'}`
    }
    return 'All Subscribers'
  }

  renderFact = (label, value, key) => {
    return (
      <React.Fragment key={key || label}>
        <dt>{label}</dt>
        <dd>{value}</dd>
      </React.Fragment>
    )
  }

  renderDetailBody = () => {
    const { detail, detailLoading } = this.state

    if (detailLoading) {
      return (
        <div className="text-center p-4">
          <i className="icofont icofont-spinner-alt-2 icofont-spin f-24"></i>
          <div className="mt-2 text-muted">Loading campaign details...</div>
        </div>
      )
    }

    if (!detail) {
      return <div className="text-center p-4 text-muted">No details found for this campaign.</div>
    }

    const platforms = detail.platforms ? detail.platforms.split(',') : ['ios', 'android']
    const action = this.getClickAction(detail)
    const creator = detail.creator
      ? `${detail.creator.first_name || ''} ${detail.creator.last_name || ''}`.trim() || detail.creator.email
      : ''

    const schedule = detail.schedule_type === 'scheduled' && detail.scheduled_at
      ? `${moment(detail.scheduled_at).format('MMM DD, YYYY hh:mm A')}${detail.timezone_value ? ' (' + detail.timezone_value + ')' : ''}`
      : 'Sent Immediately'

    return (
      <div className="pd-wrap">
        <div className="pd-header">
          <div className="pd-header-top">
            <div>
              <div className="pd-title">{detail.title_en || detail.title_ar || 'Untitled'}</div>
              {detail.title_ar && detail.title_en && (
                <div className="pd-title-ar" dir="rtl">{detail.title_ar}</div>
              )}
            </div>
            {this.renderStatusBadge(detail.status)}
          </div>
          <div className="pd-sub">
            {moment(detail.created_at).format('MMM DD, YYYY · hh:mm A')}
            {creator ? ` · by ${creator}` : ''}
          </div>
        </div>

        <div className="pd-block">
          <div className="pd-block-title">Message</div>
          {detail.message_en && <div className="pd-msg">{detail.message_en}</div>}
          {detail.message_ar && <div className="pd-msg" dir="rtl">{detail.message_ar}</div>}
          {detail.banner_image && (
            <img src={Constant.getImage() + detail.banner_image} alt="Banner" className="pd-banner" />
          )}
        </div>

        <div className="pd-block">
          <div className="pd-block-title">Delivery</div>
          <dl className="pd-facts">
            {this.renderFact('Audience', this.getAudienceText(detail))}
            {this.renderFact('Platforms', (
              <span>
                {platforms.includes('ios') && <span className="review-badge badge-ios">iOS</span>}
                {platforms.includes('android') && <span className="review-badge badge-android">Android</span>}
              </span>
            ))}
            {this.renderFact('Click Action', (
              <span>
                {action.main}
                {action.sub && <span className="pd-mono">{action.sub}</span>}
              </span>
            ))}
            {this.renderFact('Schedule', schedule)}
            {detail.ttl_hours ? this.renderFact('TTL', `${detail.ttl_hours} hours`) : null}
            {detail.send_rate ? this.renderFact('Send Rate', `${detail.send_rate} / second`) : null}
            {this.renderFact('Devices Targeted', detail.audience_type === 'all' ? 'Broadcast (not tracked)' : detail.sent_count || 0)}
            {detail.pushwoosh_message_id
              ? this.renderFact('Pushwoosh ID', <span className="pd-mono">{detail.pushwoosh_message_id}</span>)
              : null}
          </dl>
        </div>
      </div>
    )
  }

  render() {
    const customSearchRender = (searchText, handleSearch, hideSearch) => {
      return (
        <div className="container">
          <div className="d-flex justify-content-around">
            <i className="f-16 icofont icofont-search m-t-10 m-r-10"></i>
            <input
              type="search"
              className="form-control custom-input-search"
              placeholder="Search Campaigns..."
              value={this.state.keyword}
              name="keyword"
              onChange={this.onSearch}
            />
            <span
              className="pointer m-t-5"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.clearSearch(hideSearch)
              }}
            >
              <i className="f-24 icofont icofont-close m-l-10"></i>
            </span>
          </div>
        </div>
      )
    }

    const columns = [
      {
        name: 'title_en',
        label: 'Title',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (title) => {
            return <div style={{ fontWeight: '700', color: '#2d3561' }}>{title || 'Untitled'}</div>
          }
        }
      },
      {
        name: 'message_en',
        label: 'Message',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (msg) => {
            const shortMsg = msg ? (msg.length > 50 ? msg.substring(0, 50) + '...' : msg) : ''
            return <div style={{ color: '#6c757d', fontSize: '13px' }}>{shortMsg}</div>
          }
        }
      },
      {
        name: 'audience_type',
        label: 'Audience',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (audience) => {
            return (
              <span style={{
                padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '600',
                backgroundColor: '#f8f9fa', border: '1px solid #ced4da', textTransform: 'capitalize'
              }}>
                {audience || 'All'}
              </span>
            )
          }
        }
      },
      {
        name: 'platforms',
        label: 'Platforms',
        options: {
          filter: true,
          sort: false,
          customBodyRender: (val) => {
            const platforms = val ? val.split(',') : ['ios', 'android']
            return (
              <div>
                {platforms.includes('ios') && <span style={{ padding: '2px 6px', borderRadius: '4px', fontSize: '11px', backgroundColor: '#e8f5e9', color: '#2e7d32', marginRight: '4px' }}>iOS</span>}
                {platforms.includes('android') && <span style={{ padding: '2px 6px', borderRadius: '4px', fontSize: '11px', backgroundColor: '#e3f2fd', color: '#1976d2' }}>Android</span>}
              </div>
            )
          }
        }
      },
      {
        name: 'status',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (status) => this.renderStatusBadge(status)
        }
      },
      {
        name: 'created_at',
        label: 'Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (date) => {
            return (
              <div style={{ fontSize: '13px' }}>
                <div>{moment(date).format('MMM DD, YYYY')}</div>
                <div className="text-muted">{moment(date).format('hh:mm A')}</div>
              </div>
            )
          }
        }
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id) => {
            return (
              <button
                className="btn btn-sm btn-outline-primary"
                onClick={() => this.openDetail(id)}
              >
                View
              </button>
            )
          }
        }
      }
    ]

    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      serverSide: true,
      count: this.state.totalCount,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState({ pageNumber: currentPage }, () => { this.loadData() })
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState({ limit: numberOfRows, pageNumber: 0 }, () => { this.loadData() })
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? <Loader open={this.state.isLoading} /> : 'No campaigns found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
      customSearchRender: customSearchRender,
      onSearchClose: () => {
        this.clearSearch()
      }
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Push Campaign History</h4>
                    </div>
                  </div>
                  <Link to="/push-composer" className="btn btn-primary btn-sm" style={{ marginLeft: '10px' }}>
                    <i className="icofont icofont-plus"></i> New Campaign
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Push Campaigns</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <div className="dt-responsive table-responsive">
                      <MUIDataTable
                        title=""
                        data={this.state.campaigns}
                        columns={columns}
                        options={options}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          open={this.state.detailOpen}
          onClose={this.closeDetail}
          center
          styles={{ modal: { maxWidth: 560, width: '100%', borderRadius: 10, padding: '24px' } }}
        >
          <div className="pd-modal-heading">Campaign Report</div>
          {this.renderDetailBody()}
        </Modal>
      </div>
    )
  }
}

export default PushHistory
